export const MONTHS_ID = [
  'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember',
];

export function formatRp(value) {
  const n = Number(value || 0);
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(Math.round(n));
  const str = abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${sign}Rp${str}`;
}

export function parseNumber(input) {
  if (input === '' || input === null || input === undefined) return 0;
  const cleaned = String(input).replace(/[^0-9\-]/g, '');
  return Number(cleaned) || 0;
}

export function formatThousands(input) {
  if (input === '' || input === null || input === undefined) return '';
  const raw = String(input).replace(/[^0-9\-]/g, '');
  if (raw === '' || raw === '-') return raw;
  const n = Number(raw);
  if (isNaN(n)) return '';
  return n.toLocaleString('id-ID');
}

export function daysInMonth(year, month /* 1-12 */) {
  return new Date(year, month, 0).getDate();
}
